module.exports = __webpack_public_path__ + "media/place_bet.dab8fa0f.mp3";